import { BridgeType } from '../context';

export type ServerEventsContext = Awaited<ReturnType<BridgeType['getServerEventsContext']>>;

export const useServerEventsContext = (bridge: BridgeType) => {
  const getServerContext = async (): Promise<ServerEventsContext | null> => {
    if (!bridge.isWebViewBridgeAvailable) return null;
    try {
      return await bridge.getServerEventsContext();
    } catch (e) {
      console.error('[ServerEventsContext] getServerContext failed:', e);
      return null;
    }
  };

  return { getServerContext };
};
